/** Curator IVS rooms run in us-east-1 (see strapi docs/curator-conversations-frontend.md). */
export const IVS_CHAT_REGION =
  process.env.REACT_APP_IVS_CHAT_REGION ||
  process.env.REACT_APP_AWS_REGION ||
  "us-east-1";

/** Fallback list polling when the events socket is unavailable. */
export const CONVERSATIONS_POLL_INTERVAL_MS = 60_000;
